import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";
import { delay } from "./Utils";

const AddLineManager = (modal) => {
  const form = document.getElementById("add_line_manager_form");

  if (form) {
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      const data = new FormData(form);
      data.append("action", "add_line_manager");

      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
           // console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Save";
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: "/users",
            });
            modal.hide();
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          spinner.classList.add("hidden!");
          spinnerText.textContent = "Save";
          createToast({
            type: "error",
            message: "System Error!",
            duration: 1000,
          });
        });
    });
  }
};

export { AddLineManager };
